import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { Field } from 'formik';
import Modal from 'react-bootstrap/Modal';
import { DropdownList } from 'react-widgets';
import { isMobileOnly } from 'react-device-detect';
import DatePicker from 'react-datepicker';
import Select from 'react-select';

import Image from '../../../../../../../core-components/Image';
import ValidatedFormInputField from '../../../../../../../core-components/ValidatedFormInputField';
import ValidatedFormTextArea from '../../../../../../../core-components/ValidatedFormTextArea';
import Checkbox from '../../../../../../../core-components/Checkbox';
import countriesList from '../../../../../../../utils/countriesNames.json';

import styles from './DetailsStep.module.scss';
import 'react-datepicker/dist/react-datepicker.css';
import {
  getPlaceHolderTextForBgvCityDropDown,
  getTrimmedValue
} from '../../../../../../../utils/utilities';
import { COUNTRY_CODES } from '../../../../../../../utils/commonConstant';

const stateAndCity = require('country-state-city');
const lookup = require('country-code-lookup');

const getCityValue = (data) => {
  if (!isEmpty(data) && data.endsWith('*')) {
    return data.slice(0, -1);
  }
  return data;
};

export default (props) => {
  const { handleSubmit, isSubmitting, values, errors, setFieldValue, touched } = props;
  const isValidForm =
    isEmpty(errors) &&
    ((values.start_date &&
      values.end_date &&
      values.start_date < values.end_date &&
      !values.currently_working) ||
      (values.start_date && values.currently_working));

  const isStartEndDateSame = () => {
    return values.end_date && values.start_date - values.end_date === 0;
  };

  const setValue = (fieldname, value, withSpace) => {
    setFieldValue(fieldname, getTrimmedValue(value, withSpace));
  };

  const getNames = (arr) => {
    return arr.map((obj) => obj.name);
  };

  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState(getCityValue(values?.city || ''));

  const handleCityChange = (selectedOption) => {
    setFieldValue('city', selectedOption?.value || '');
    setSelectedCity(selectedOption);
  };

  useEffect(() => {
    const country = props.values.country;

    if (country) {
      const countryDetails = lookup.byCountry(country);
      let countryCode;

      if (countryDetails) {
        countryCode = countryDetails.iso2;
      } else {
        countryCode = COUNTRY_CODES[country];
      }

      const val = getNames(stateAndCity.City.getCitiesOfCountry(countryCode));
      const cityOptions = val.map((city) => ({
        label: city,
        value: city
      }));

      setCities(cityOptions);
    }

    if (selectedCity === null && !isEmpty(props.values.city)) {
      setSelectedCity({ label: props.values.city, value: props.values.city });
    }
  }, [props.values]);

  return (
    <Modal
      size='lg'
      show={props.show}
      onHide={props.onHide}
      aria-labelledby='contained-modal-title-vcenter'
      backdrop='static'
      dialogClassName='verificationModal'
      backdropClassName={'customBGVModalBackdrop'}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          <div className={styles.employmentModalTitle}>
            {(!props.isEdit ? 'Add' : 'Edit') + ' Employment'}
          </div>
          <div className={styles.employmentModalSubTitle}>{'Step 1 of 3'}</div>
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit} className={styles.detailsStepForm}>
        <Modal.Body>
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <Form.Label>
                Company Name <span>*</span>
              </Form.Label>
              <Field type='text' name='company_name' component={ValidatedFormInputField} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} xs={12} md={6} lg={6}>
              <Form.Label>
                Your Employee ID <span>*</span>
              </Form.Label>
              <Field
                type='text'
                name='employee_id'
                component={ValidatedFormInputField}
                onBlur={(e) => {
                  props?.handleBlur(e);
                  setValue('employee_id', values?.employee_id, true);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} xs={12} md={6} lg={6} className={styles.countries}>
              <Form.Label>
                Country<span>*</span>
              </Form.Label>
              <DropdownList
                data={countriesList.countries}
                value={values.country}
                selectIcon={<Image name='dropdownArrow.svg' />}
                onChange={(value) => {
                  setFieldValue('country', value);
                  setFieldValue('city', '');
                  setSelectedCity(null);
                  setCity('');
                }}
              />
            </Col>
            <Col sm={12} xs={12} md={6} lg={6}>
              <Form.Label>
                City<span>*</span>
              </Form.Label>
              {isEmpty(cities) ? (
                <Field
                  type='text'
                  name='city'
                  placeholder='Please type city name'
                  value={city}
                  onChange={(e) => {
                    setFieldValue('city', e.target.value);
                    setCity(e.target.value);
                  }}
                  onBlur={() => {
                    if (!isEmpty(values.city) && !values.city.endsWith('*'))
                      setFieldValue('city', getTrimmedValue(values.city, true) + `*`);

                    setCity(getTrimmedValue(values.city, true));
                  }}
                  component={ValidatedFormInputField}
                />
              ) : (
                <Select
                  options={cities}
                  value={selectedCity}
                  onChange={handleCityChange}
                  isClearable
                  isSearchable
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <Form.Label>
                Designation <span>*</span>
              </Form.Label>
              <Field type='text' name='designation' component={ValidatedFormInputField} />
            </Col>
          </Row>
          <Form.Label>
            Duration <span>*</span>
          </Form.Label>
          <Row className={'detailsStartDate'}>
            <Col
              sm={12}
              xs={12}
              md={6}
              lg={6}
              className={
                values.start_date &&
                values.end_date &&
                values.start_date > values.end_date &&
                !values.currently_working
                  ? 'empDateError'
                  : null
              }
            >
              {/* <Field
                key={1}
                name='start_date'
                placeholder='Start date'
                inputIconPosition='before'
                component={SingleDatePicker}
              /> */}
              <DatePicker
                placeholderText={'Start date'}
                selected={values.start_date ? values.start_date : null}
                dateFormat='dd MMM yyyy'
                isClearable={values.start_date ? true : false}
                className={styles.datePicker}
                // disabled={props.disabled ? props.disabled : false}
                onChange={(date) => {
                  setFieldValue('start_date', date);
                }}
                onChangeRaw={(e) => e.preventDefault()}
                maxDate={new Date()}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
              {!isMobileOnly &&
              values.start_date &&
              values.end_date &&
              values.start_date > values.end_date &&
              !values.currently_working ? (
                <div className={styles.errorMsg}>{'Please enter a valid date'}</div>
              ) : null}
              {!!errors.start_date && touched.start_date && (
                <div className={styles.errorMsg}>{errors.start_date}</div>
              )}
            </Col>
            <Col
              sm={12}
              xs={12}
              md={6}
              lg={6}
              className={
                values.start_date &&
                values.end_date &&
                values.start_date > values.end_date &&
                !values.currently_working
                  ? 'empDateError'
                  : null
              }
            >
              {/* <Field
                key={2}
                name='end_date'
                component={SingleDatePicker}
                placeholder='Last working date'
                inputIconPosition='before'
                disabled={values.currently_working}
              /> */}
              <DatePicker
                placeholderText={'Last working date'}
                selected={values.end_date ? values.end_date : null}
                dateFormat='dd MMM yyyy'
                isClearable={values.end_date ? true : false}
                className={values.currently_working ? styles.disabledDatePicker : styles.datePicker}
                disabled={values.currently_working}
                onChange={(date) => {
                  setFieldValue('end_date', date);
                }}
                onChangeRaw={(e) => e.preventDefault()}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
              />
              {!!errors.end_date && touched.end_date && (
                <div className={styles.errorMsg}>{errors.end_date}</div>
              )}
              {(isMobileOnly &&
                values.start_date &&
                values.end_date &&
                values.start_date > values.end_date &&
                !values.currently_working) ||
              isStartEndDateSame() ? (
                <div className={styles.mobErrorMsg}>
                  {!isStartEndDateSame()
                    ? 'Please enter a valid date'
                    : 'Start and End date cannot be same'}
                </div>
              ) : null}
            </Col>
          </Row>
          <Row className={styles.checkBoxLabel}>
            <Col sm={12} xs={12} md={6} lg={6}>
              <Field
                custom
                className='currently_working'
                name='currently_working'
                label='I currently work here'
                component={Checkbox}
              />
            </Col>
          </Row>
          <Row className={styles.textArea}>
            <Col sm={12} xs={12} md={12} lg={12}>
              <Field
                name='reason'
                rows='2'
                label='Reason for leaving'
                disabled={values.currently_working}
                component={ValidatedFormTextArea}
                onBlur={(e) => {
                  props?.handleBlur(e);
                  setValue('reason', values?.reason, true);
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className={styles.employmentSubmitBtn}>
          <Col sm={6} xs={6} md={3} lg={3}>
            <Button
              className={styles.cancelBtn}
              onClick={(e) => {
                props.onHide();
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col sm={6} xs={6} md={3} lg={3}>
            <Button
              type='submit'
              className={!isSubmitting && isValidForm ? styles.activeBtn : styles.disabledBtn}
              disabled={isSubmitting || !isValidForm}
            >
              Next
            </Button>
          </Col>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
